import { render, staticRenderFns } from "./PersonalityExamResults.vue?vue&type=template&id=97a63b50&"
import script from "./PersonalityExamResults.vue?vue&type=script&lang=js&"
export * from "./PersonalityExamResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports